<template>
  <modal id="modalConfirmExit" ref="modalConfirmExit" size="modal-sm">
    <template #body>
      <p>Tem certeza de que deseja sair sem salvar?</p>

      <div class="text-right mt-5">
        <button type="button" class="btn-primary-invert font-normal" @click="$emit('denyExit')">
          Não
        </button>

        <button type="button" class="btn-primary font-normal ml-1" @click="$emit('acceptExit')">
          Sim
        </button>
      </div>
    </template>
  </modal>
</template>

<script>

import Modal from '@/Shared/Modal/Modal.vue'
export default {
  name: 'ExitWithoutModal',

  components: {
    Modal,
  },

  emits: ['acceptExit', 'denyExit'],

  methods: {
    openModal() {
      this.$refs.modalConfirmExit.open()
    },

    closeModal() {
      this.$refs.modalConfirmExit.close()
    },
  },
}

</script>
